/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![MicrophoneDenyIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAACDklEQVR4nM1UTWsUQRBdvPhx8KIheFDQkyYRL+rV62i6PiZktmoSJP8hnjwtKHjxoMT4B4QQhBy9iApi8BeI/oFEMASNq4fkEpTq6daJzOzOritYsOx0zdR7Xa9fdav1l+EoZyB5Biw7QLKFJK8RFVujCCS5h6w/qn5AcrcxEJGcRpY1YP2GqLNFLocAtocsi87lJ91Mfh5ZupHEsVxvBA6kn2MR0dzFsPtXRU4WbQ2g48D6PuQKEtLn/WVgWSu3fm1h4UjIexDmmyfK4PYPoJPFs+z0JQCTpYIASL/6HGYTf4CPJ1k2Fjr50qADPXB402l7KhC/KMsRwQP5rQEk0oPuYL1dnE1+43deusxyIU3nTwXwPf9tqskQBPIxSeaPh3d3BrYpsL5FkvU6AvTFutrpdA7Ze7NiIZdJJV177mlPIP3uPezcsWItW5W7JHkaOxkooiNc2r4SCFfrZECWpViXJMnhRgRWFIof2Hp6Zu5cdReybUMYZLxfHrreBOZrkn0k2Y1TC5CdRdYnBoosn4B1xbnsjN9A2r5krrGaaOH+MpEsBydsRJKqCOCb4dvlVtOwaf01SCS7QPoQUS9nWXbUDp85v+pzwe/I+rLxGcSwAjsPL1e91/eR5XG8PoYK8BeXLCHpu9IcfEDSR73kGyowEIwU9J8TgF0ddYNWulKGDiRZrz1k1jcj6eK/jp/vp5mP9vWzsAAAAABJRU5ErkJggg==)
 */
export const MicrophoneDenyIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M21.76.83a5.02 5.02 0 0 1 .78 7.7 5 5 0 0 1-7.07 0 5.02 5.02 0 0 1 0-7.07 5 5 0 0 1 6.29-.63Zm-4.88 2.05a3 3 0 0 1 3.41-.59l-4 4a3 3 0 0 1 .59-3.41Zm4.83.83-4 4a3 3 0 0 0 4-4Z"
        clipRule="evenodd"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M12 2c.33 0 .51.35.4.66a6.99 6.99 0 0 0 3.04 8.37c.2.12.31.37.21.6A4 4 0 0 1 8 10V6a4 4 0 0 1 4-4Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M17.55 12.29c.1-.23.33-.37.58-.34.29.03.58.05.87.05h.04c.35 0 .63.32.51.65A8 8 0 0 1 13 17.94V20h2a1 1 0 1 1 0 2H9a1 1 0 1 1 0-2h2v-2.06A8 8 0 0 1 4 10a1 1 0 0 1 2 0 6 6 0 0 0 11.55 2.29Z"
        className={colorClass}
      />
    </svg>
  );
};
